import React from 'react';
import webapi from '../../../api/webapi';
import Modal from 'react-bootstrap/Modal'


class PerSurfParagraphList extends React.Component{ 

    state = { modalshow: false};
    state = { modalHeader : '' }
    state = { modalText : '' }

    GetTextCode(){
        if (window.getSelection)
        {
            //console.log(ParagraphCode);

            var selection = window.getSelection ();
            //console.log(selection);

            var start = selection.anchorOffset;
            var end = selection.focusOffset;
            //console.log(start);
            //console.log(end);
            this.setState({modalHeader: selection.anchorNode.textContent.substring(start,end)});

            var s = selection.anchorNode.textContent.substring(0,start);
            //console.log(s);
            
            var Sequence = ((s.length - s.replaceAll(" ", "").length + 1));
            //Sequence=Sequence.substring(Sequence.length-3,Sequence.length) 
            //console.log(Sequence);

            //var TextCode = Sequence
            //console.log(TextCode);

            return Sequence;

        }
    }

    showModal = async event => {
        event.preventDefault();
        
        var ParagraphTextSequence=this.GetTextCode();
        
        //console.log("id:",event.target.id);
        //console.log("id:",this.state.modalshow);
        if (!this.state.modalshow)
        {
            //console.log("url:",'sentence/persiandetail/'+this.props.SelectedBookVersion+'/'+ParagraphTextSequence);
            const responseText= await webapi.get('sentence/persiandetail/'+this.props.SelectedBookVersion+'/'+ParagraphTextSequence);
            this.setState({modalText:responseText.data});
            //alert(responseText.data);
            //this.setState({modalHeader: this.state.modalText.Transcription});
            //console.log("responseText:",responseText);
            if (responseText.data!=='')
                this.setState({modalshow: true});
            //alert(this.state.modalText);
            //this.setState({modalshow: false});
        }
        else
        {
            this.setState({modalshow: false});
            this.setState({modalText: '' });
        }
        
        //console.log("modalText:",this.state.modalText);
        //this.setState({modalshow: true});
    };

    CloseModal = event => {
        event.preventDefault();
        this.setState({modalshow: false});
    }

    //const  SurfParagraphList = props => {
    render() {
        return (
            <div>
                <div className="alert" role="alert">
                    {this.props.pageData.length!==0 && this.props.pageData[0].F89905!== undefined?this.props.pageData[0].F89905:89905/*"برای مشاهده برچسب‌های واژه روی شماره کلیک کنید"*/}
                </div>
                {
                    this.props.ParagraphList.map((Paragraph) =>{
                    return  (
                            <div className="container-fluid" id="texts_main_content" key={Paragraph.Code}>
                                <div className="container">
                                    <div id="texts_main_content_body">
                                        {
                                            (Paragraph.Text!=="")
                                            ?
                                            //<p className="right_align_pahlavi" ParagraphCode={Paragraph.Code} onDoubleClick={this.showModal}>
                                            <p className="right_align" id="test" style={{fontFamily:"Tahoma",fontSize:"13px"}}  ParagraphCode={Paragraph.Code} onDoubleClick={this.showModal}>
                                                {Paragraph.Text}
                                            </p>
                                            :
                                            null
                                        }
                                        {
                                            (Paragraph.Transcription!=="")
                                            ?
                                            <p className="left_align" ParagraphCode={Paragraph.Code} onDoubleClick={this.showModal}>
                                                {Paragraph.Sequence}- {Paragraph.Transcription}
                                            </p>
                                            :
                                            null
                                        }
                                        {
                                            (Paragraph.Translation!=="")
                                            ?
                                            //<p className="right_align" style={{fontFamily:"Tahoma",fontSize:"13px"}}>
                                            <p className="right_align_pahlavi" ParagraphCode={Paragraph.Code} onDoubleClick={this.showModal}>
                                                {Paragraph.Translation}
                                            </p>
                                            :
                                            null
                                        }
                                        {
                                            (Paragraph.EnTranslation!=="")
                                            ?
                                            <p className="left_align" style={{fontFamily:"Tahoma",fontSize:"13px"}}>
                                                {Paragraph.EnTranslation}
                                            </p>
                                            :
                                            null
                                        }
                                        {
                                            (Paragraph.Note!=="")
                                            ?
                                            <p id="texts_Note_content_body">
                                                {Paragraph.Note}
                                            </p>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
                {
                    (this.state.modalText) 
                    ?
                    (
                        <Modal
                            show={this.state.modalshow}
                            onHide={() => this.setState({modalshow: false})}
                            dialogClassName="modal-90w"
                            aria-labelledby="modal-styling-title"
                            centered
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="modal-styling-title">
                                    
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <table>
                                    <tbody>
                                        {
                                            this.state.modalText.map((BookVersion) =>{
                                                return( 
                                                    <tr>
                                                        <td>
                                                            {(BookVersion.IsMaster===0)
                                                            ?
                                                            (<div className="Caption">{BookVersion.BookVersionTitle}</div>)
                                                            :
                                                            (<div className="Caption" style={{backgroundColor:'lawngreen'}}>{BookVersion.BookVersionTitle}</div>)
                                                            }
                                                        </td>
                                                        <td>
                                                            <div>
                                                                {BookVersion.SentenceText[0].PreWord}   
                                                                <mark style={{backgroundColor:'yellow'}}>
                                                                    {BookVersion.SentenceText[0].Word}
                                                                </mark>
                                                                {BookVersion.SentenceText[0].PostWord}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                                {/*
                                <br />
                                <div className="ltrData">
                                    {
                                        this.state.modalText.Paragraph.map((ParagraphItem,k) =>{
                                            return(
                                                (ParagraphItem.Text===this.state.modalHeader)
                                                ?
                                                    (<span className='HighLight' key={k}>{ParagraphItem.Text}</span>)
                                                :
                                                    (ParagraphItem.Text)
                                            )
                                        })
                                    }
                                </div>
                                 <br />
                                <div className="rtlDataFa">{this.state.modalText.ParagraphTranslation}</div>
                                <div className="rtlDataFaNote">{this.state.modalText.ParagraphNote}</div> */}
                            </Modal.Body>
                        </Modal>
                    )
                    :
                    null
                }
            </div>
        )
    }
}

export default PerSurfParagraphList;